<div class="dashboard">
  <top-bar></top-bar>
  @if (selectedPatientID) {
  <div class="modules-container" id="modulesContainer">
    <div class="horizontal-flex-list">
      <a
        [routerLink]="['/graphs', selectedPatientID, 'targets']"
        routerLinkActive="selected"
      >
        <span>Targets</span>
      </a>
      <a
        [routerLink]="['/graphs', selectedPatientID, 'programs']"
        routerLinkActive="selected"
      >
        <span>Programs</span>
      </a>
      <a
        [routerLink]="['/graphs', selectedPatientID, 'behaviors']"
        routerLinkActive="selected"
      >
        <span>Behaviors</span>
      </a>
      <a
        [routerLink]="['/graphs', selectedPatientID, 'mixed']"
        routerLinkActive="selected"
      >
        <span>Mixed</span>
      </a>
      <a
        [routerLink]="['/graphs', selectedPatientID, 'annotations']"
        routerLinkActive="selected"
      >
        <span>Annotations</span>
      </a>
    </div>

    <router-outlet (activate)="activated($event)"></router-outlet>
  </div>
  }
</div>
